import { render } from "./WeProposeApp.vue?vue&type=template&id=5cd3d026&scoped=true&ts=true&lang=pug"
import script from "./WeProposeApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeProposeApp.vue?vue&type=script&lang=ts&setup=true"

import "./WeProposeApp.vue?vue&type=style&index=0&id=5cd3d026&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd3d026"]])

export default __exports__